/** Live lesson WebSocket client (see server routes/live.ts for the protocol). */

import type { TracePoint } from '@solfo/shared';
import { getToken } from './api.ts';
import type { RtcSignal } from './rtc.ts';

export interface LiveMessages {
  presence: { type: 'presence'; coach: boolean; student: boolean };
  trace: { type: 'trace'; points: TracePoint[] };
  exercise: { type: 'exercise'; exerciseId: string; rootMidi: number; tempoBpm: number };
  'exercise-started': { type: 'exercise-started'; exerciseId: string; countInSec: number };
  'exercise-finished': { type: 'exercise-finished'; score: number | null };
  note: { type: 'note'; text: string };
  /** Coach-only: show/hide the pitch visualizer on the student's screen. */
  visualizer: { type: 'visualizer'; show: boolean };
}
export type LiveMessage = (LiveMessages[keyof LiveMessages] | RtcSignal) & {
  from?: 'coach' | 'student';
};

export function openLiveSocket(lessonId: string): WebSocket {
  const proto = location.protocol === 'https:' ? 'wss' : 'ws';
  const token = encodeURIComponent(getToken() ?? '');
  return new WebSocket(`${proto}://${location.host}/api/live/${lessonId}?token=${token}`);
}

export function sendLive(ws: WebSocket | null, msg: LiveMessage): void {
  if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(msg));
}
